import React, { useEffect } from 'react'
import Modal, { Styles } from 'react-modal'
import { useSwipeable } from 'react-swipeable'
import './Modal.css'

import { isScreenSize, ScreenSize } from '../ui/style/ScreenSize'
import { css } from 'src/ui/style/css'

// Make sure to bind modal to your appElement (https://reactcommunity.org/react-modal/accessibility/)
Modal.setAppElement('#modal-root')

interface ModalProps {
    children: React.ReactNode
    open: boolean
    onClose: () => void
    right?: boolean
    fitContent?: boolean
    fullScreen?: boolean
    isFloorPlan?: boolean
    isInfoMessage?: boolean
}

const CustomModal: React.FC<ModalProps> = ({
    children,
    open,
    onClose,
    right,
    fitContent = true,
    fullScreen,
    isFloorPlan,
    isInfoMessage
}) => {
    const rightModalClassNames = {
        base: 'right-modal-content',
        afterOpen: 'right-modal-content--after-open',
        beforeClose: 'right-modal-content--before-close'
    }

    const handleClose = () => {
        onClose()
    }

    const handlers = useSwipeable({
        onSwipedLeft: handleClose,
        onSwipedRight: handleClose
    })
    const isSmallMobile = isScreenSize(ScreenSize.Sizes.sm)
    const isMediumMobile = isScreenSize(ScreenSize.Sizes.md)
    const isLargeMobile = isScreenSize(ScreenSize.Sizes.lg)

    const getWidth = () => {
        if (isSmallMobile) return '100%'
        if (isMediumMobile) return '85%'
        if (isLargeMobile) return '45%'

        return '30%'
    }

    useEffect(() => {
        const body = document.body
        const previousOverflow = body.style.overflow
        const previousPaddingRight = body.style.paddingRight

        if (open) {
            body.style.overflow = 'hidden'

            const supportsStableScrollbarGutter =
                typeof CSS !== 'undefined' &&
                CSS.supports?.('scrollbar-gutter: stable')

            if (!isFloorPlan && !supportsStableScrollbarGutter) {
                const scrollbarWidth =
                    window.innerWidth - document.documentElement.clientWidth

                if (scrollbarWidth > 0) {
                    const currentPaddingRight = parseFloat(
                        window.getComputedStyle(body).paddingRight || '0'
                    )
                    body.style.paddingRight = `${
                        currentPaddingRight + scrollbarWidth
                    }px`
                }
            }
        }

        return () => {
            body.style.overflow = previousOverflow
            body.style.paddingRight = previousPaddingRight
        }
    }, [open, isFloorPlan])

    const customStyles: Styles = {
        content: {
            height: fitContent ? 'fit-content' : '100%',
            top: '50%',
            left: '50%',
            width: getWidth(),
            // right: 'auto'
            // bottom: 'auto'
            // marginRight: '-50%'
            transform: 'translate(-50%, -50%)',
            padding: '0'
            // overflowY: 'scroll'
        },
        overlay: {
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            zIndex: 9999
            // overflowY: isScrollable ? 'scroll' : 'hidden'
        }
    }

    if (isFloorPlan) {
        customStyles.content = {
            ...customStyles.content,
            height: '100%',
            width: '95%'
            // bottom: '5%'
            // top: '54.5%'
        }
        customStyles.overlay = {
            ...customStyles.overlay,
            backgroundColor: 'none',
            zIndex: 1103
        }
    }

    if (isInfoMessage) {
        customStyles.content = {
            ...customStyles.content,
            height: 'fit-content',
            // width: '80%',
            padding: '0'
        }
        customStyles.overlay = {
            ...customStyles.overlay,
            backgroundColor: 'rgba(0, 0, 0, 0.75)',
            // width: '100%',
            zIndex: 100
        }
    }

    if (fullScreen) {
        customStyles.content = {
            ...customStyles.content,
            top: '0',
            left: '0',
            right: '0',
            bottom: '0',
            width: '100%',
            height: '100%',
            maxWidth: '100%',
            overflow: 'hidden',
            backgroundColor: 'transparent',
            transform: 'none',
            border: 'none',
            borderRadius: '0',
            padding: '0'
        }
    }

    if (right && !fullScreen) {
        customStyles.content = {
            ...customStyles.content,
            top: '50%',
            left: 'auto',
            right: '0',
            transform: 'translate(0, -50%)'
        }
    }

    return (
        <Modal
            isOpen={open}
            onRequestClose={handleClose}
            style={customStyles}
            className={right ? rightModalClassNames : undefined}
            preventScroll={true}
            closeTimeoutMS={500}
        >
            <div
                id={'handlers'}
                {...handlers}
                css={
                    (isFloorPlan || fullScreen) &&
                    css`
                        width: 100%;
                        height: 100%;
                    `
                }
            >
                {children}
            </div>
        </Modal>
        // <>
        //     <View
        //         css={css`
        //             width: 350px;
        //             min-height: 100vh;
        //             box-shadow: 0px 4px 8px rgb(0 0 0 / 16%);
        //             background-color: #fff;
        //             position: fixed;
        //             top: 0;
        //             //left: -100%;
        //             z-index: 1000;
        //             transition: 0.5s;
        //             left: 0;
        //         `}
        //         onClick={onClose}
        //     >
        //         {children}
        //     </View>
        //     <View
        //         css={css`
        //             position: fixed;
        //             top: 0;
        //             left: 0;
        //             width: 100%;
        //             height: 100%;
        //             background-color: rgba(0, 0, 0, 0.4);
        //             transition: 0.5s;
        //             opacity: 1;
        //             visibility: visible;
        //         `}
        //         onClick={onClose}
        //     />
        // </>
    )
}

export default CustomModal
